import { styled, Theme } from '@nexelem/deprecated-theme';
import { ButtonProps, Button } from '@nexelem/components';
import { SyntheticEvent } from 'react';

type IconButtonProps = ButtonProps & {
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly isActive?: boolean;
  readonly onMouseDown?: (evt: SyntheticEvent) => void;
};

const StyledButton = styled(Button)<{ isActive?: boolean }>(({ theme, disabled, isActive, ...rest }) => {
  const typedTheme = theme as Theme;
  const { getColor } = typedTheme.palette;
  const { active } = typedTheme.client.buttons.primaryButton.text.states;
  const baseStyles = {
    cursor: disabled ? 'not-allowed' : 'pointer',
    padding: typedTheme.spacing(2.5),
    minWidth: 'unset',
    '> span': {
      margin: 0,
    },
  };
  if (isActive) {
    return {
      '&&': {
        ...baseStyles,
        color: getColor(active.color),
        backgroundColor: getColor(active.backgroundColor),
      },
    };
  }
  return {
    '&&': baseStyles,
  };
});

export const IconButton = ({ ariaLabel, ...props }: IconButtonProps) => (
  <StyledButton aria-label={ariaLabel} {...props} />
);
IconButton.displayName = 'IconButton';
